export const searchThemesFromTrends = {
    description:
        'テーマごとに市場からの注目度と出願数の成長率が確認できます。\n' +
        'また、バブルチャートに表示する対象のテーマを絞り込むことができます。\n' +
        '特許出願数と投資総額の上位10テーマを出願数の時系列で確認できます。',
    subtitle: 'テーマの動向',
    subDescription: '投資成長率と特許出願成数長率が高いテーマから探索することができます。',
    vectorSearchDescription:
        '検索キーワードに関連度が高いとされるテーマを、ベクトル類似度を基に機械的に抽出しています。\n結果の納得感が低い場合は、「カテゴリで絞り込む」をご活用ください。',
    filterLabel: '表示テーマのカテゴリを絞り込む',
    placeholder: 'カテゴリを選択',

    // バブルチャート
    chartTitle: 'テーマの動向',
    copy: 'コピー',
    labelFixedMsg: 'テーマを選択するにはラベル固定をオフにしてください',
    setting: '設定',
    aboutXAxis: 'X軸の設定項目について',
    aboutYAxis: 'Y軸の設定項目について',
    patentCount: '特許出願数',
    growthRatePatentCount: '特許出願数成長率',
    growthRateInvestmentAmount: '投資成長率',
    investmentAmount: '投資総額',
    businessAmount: 'ビジネス規模',
    noDisplay: '表示しない',
    labelShowOnly: 'テーマ名',
    labelShowMore: 'テーマ名および特許出願数',

    // タブ
    themeList: 'テーマ一覧',
    timeSeriesOfPatent: '特許出願数推移',
    timeSeriesOfInvestmentAmount: '投資総額推移',

    vectorSearchLabel: 'AIでテーマを絞り込む',
    categorySearchLabel: 'カテゴリで絞り込む',
    vectorSearchPlaceholder: '例: 電気、半導体、医薬品...',
    vectorSearchButton: '検索',
    topNLabel: '表示件数'
}
